import { useState } from 'react';
import { Modal } from '../../ui/components/Modal';
import { useAppDispatch } from '../../../store';
import { uiActions } from '../../ui/slice';
import { Button } from '../../ui/components/Button';
import { ResetPasswordForm } from './ResetPasswordForm';
import { ResetPasswordData } from '../../account/types';
import { api } from '../../account/api';

enum State {
  OPENED = 0,
  SENDING = 1,
  SUCCEEDED = 2,
  ERRORED = 3
}

export const ResetPasswordModal = () => {

  const dispatch = useAppDispatch();
  const [state, setState] = useState<State>(State.OPENED);
  const [resetPassword] = api.useResetPasswordMutation();

  const doReset = async (data: ResetPasswordData) => {
    setState(State.SENDING);
    try {
      await resetPassword(data).unwrap();
      setState(State.SUCCEEDED);
    }
    catch {
      setState(State.ERRORED);
    }
  };

  return (
    <Modal
      height={50}
      modalKey='resetPassword'
      width={30}
    >
      <h2 className='text-center text-2xl mb-4'>Reset your password</h2>
      {
        (state === State.OPENED || state === State.ERRORED) && (
          <p>
            Forgotten your password? Enter your email address and we'll send you
            a link so you can reset it.
          </p>
        )
      }
      {
        state === State.ERRORED && (
          <p className='text-white bg-red-500 rounded-sm p-2 text-center'>
            An error has occurred when trying to reset your password. Please
            try again later.
          </p>
        )
      }

      {
        (state === State.OPENED || state === State.ERRORED) && (
          <ResetPasswordForm onSubmit={doReset} />
        )
      }

      {
        state === State.SUCCEEDED && (
          <p className='px-8'>
            We've sent an email with a link to let you reset your password.
            Please check your email to continue.
          </p>
        )
      }
      <div className='flex justify-evenly items-center w-full'>
        <a
          href=""
          onClick={() => dispatch(uiActions.setCurrentModal(null))}
        >
          Cancel
        </a>
        <Button
          grow={false}
          onClick={() => dispatch(uiActions.setCurrentModal({ modal: 'signup' }))}
        >
          No account? Sign up for free!
        </Button>
      </div>
    </Modal>
  );
};
